// extracted by mini-css-extract-plugin
export default {"labelMap":"home_labelMap__T3c+V"};